const requireAll = (requireContext) => requireContext.keys().map((item) => requireContext(item));
const request = require.context('./svg', false, /\.svg$/);
requireAll(request);
